import React from 'react';
import { useHistory } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import config from '../../../../config/default';

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = config.auth0_domain;
  const clientId = config.auth0_client_id;
  const audience = config.auth0_audience;
  const redirectUrlCallback = config.redirect_url;
  const history = useHistory();

  const onRedirectCallback = appState => {
    history.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUrlCallback,
        audience,
        useRefreshTokens: true,
        useRefreshTokensFallback: true,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
